var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tr",
    { staticClass: "kpi-table__metric" },
    [
      _c("th", [_vm._v(_vm._s(_vm.index + 1))]),
      _c("td", { staticClass: "kpi-table__metric--name" }, [
        _vm._v(_vm._s(_vm.name))
      ]),
      _c("td", { staticClass: "target" }, [_vm._v(_vm._s(_vm.targetValue))]),
      _vm._l(_vm.curYear, function(monthObj, monthIndex) {
        return _c("table-cell", {
          key: _vm.field + "-" + monthIndex,
          attrs: {
            index: monthIndex,
            metric: _vm.metric,
            "month-obj": monthObj
          }
        })
      }),
      _vm._l(_vm.emptyMonthsUntilEndOfYear, function(month) {
        return _c("td", { staticClass: "kpi-table__data--empty" }, [
          _vm._v("-")
        ])
      }),
      _c("td", [_vm._v(_vm._s(_vm.targetYtd))]),
      _c("td", [_vm._v(_vm._s(_vm.actualYtd))]),
      _c("td", { class: _vm.targetYtdVarianceClass }, [
        _vm._v(_vm._s(_vm.targetYtdValueDiff))
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }